module.exports = __webpack_public_path__ + "img/48.7de2ed2f.jpg";